import { jsx as t } from "react/jsx-runtime";
import * as o from "react";
import { Root as a, Item as g, Indicator as d } from "../../../../../node_modules/@radix-ui/react-radio-group/dist/index.js";
import { cn as i } from "../../utils/cn.js";
import c from "../../../../../node_modules/lucide-react/dist/esm/icons/circle.js";
const m = o.forwardRef(({ className: s, ...e }, r) => /* @__PURE__ */ t(
  a,
  {
    className: i("gst-grid gst-gap-2", s),
    ...e,
    ref: r
  }
));
m.displayName = a.displayName;
const l = o.forwardRef(({ className: s, ...e }, r) => /* @__PURE__ */ t(
  g,
  {
    ref: r,
    className: i(
      "gst-border gst-border-solid gst-border-input gst-p-0 gst-m-0",
      // Foundation reset
      "gst-aspect-square gst-h-5 gst-w-5 gst-rounded-full gst-border gst-border-input gst-shadow-sm gst-text-white gst-ring-offset-background data-[state=checked]:gst-bg-primary data-[state=checked]:gst-shadow-none data-[state=checked]:gst-border-primary focus:gst-outline-none focus-visible:gst-ring-2 focus-visible:gst-ring-ring focus-visible:gst-ring-offset-2 disabled:gst-cursor-not-allowed disabled:gst-opacity-50",
      s
    ),
    ...e,
    children: /* @__PURE__ */ t(d, { className: "gst-flex gst-items-center gst-justify-center", children: /* @__PURE__ */ t(c, { className: "gst-h-2.5 gst-w-2.5 gst-fill-current gst-text-current" }) })
  }
));
l.displayName = g.displayName;
export {
  m as RadioGroup,
  l as RadioGroupItem
};
